// extracted by mini-css-extract-plugin
export default {"loadMoreButton":"LoadMoreButton_loadMoreButton__d6C2+","icon":"LoadMoreButton_icon__r3Dq2"};